export default {
  DATADOG_SITE: 'datadoghq.com',
  DATADOG_LOGS_CLIENT_TOKEN: 'pub5330d48bfaf9f0e6e771bd1c42f8fa19',
  DATADOG_RUM_APPLICATION_ID: 'cd2af8f1-a2c4-40a1-9ce8-162a241b105a',
  DATADOG_RUM_CLIENT_TOKEN: 'puba7a670eff291202459808b8657b253d3'
}
